const md = `
### No training, no coding - an intuitive experience to supercharge insights and efficiency

DataMixMaster puts power in the hands of the analyst. Run with insights and creativity in your flow state instead of waiting on work orders, tickets, and developers. The bottleneck has disappeared!
`;

export default md;
